import type { SwiperOptions } from 'swiper/types';
import {
  A11y, Navigation, Scrollbar, Pagination, EffectCube, EffectFade, EffectFlip, Autoplay, Manipulation,
} from 'swiper/modules';

/**
 * Slider images for the carousel.
 */
export const ImageCarouselSliderImages = [
  {
    id: '1',
    caption: 'Environmental Health SC',
    fullImageAsset: {
      url: 'https://engageinlearning.com/wp-content/uploads/Why-is-Environmental-Awareness-Important.jpg',
    },
  },
  {
    id: '2',
    caption: 'Environmental Risk and its Economic Implications',
    fullImageAsset: {
      url: 'https://goodera.com/wp-content/uploads/2019/10/environmental-risks.jpg',
    },
  },
  {
    id: '3',
    caption: 'Environmental Protection',
    fullImageAsset: {
      url: 'https://www-file.huawei.com/-/media/corporate/images/sustainability/2018/sustainability_environment.jpg',
    },
  },
  {
    id: '4',
    caption: 'Global Warming and Climate Change',
    fullImageAsset: {
      url: 'https://eponline.com/-/media/ENV/eponline/Images/2019/11/3EnvironmentalIssues.jpg',
    },
  },
  {
    id: '5',
    caption: 'Environmental Studies',
    fullImageAsset: {
      // eslint-disable-next-line max-len
      url: 'https://assetsds.cdnedge.bluemix.net/sites/default/files/styles/amp_metadata_content_image_min_696px_wide/public/feature/images/environmental_laws_1.jpg',
    },
  },
  {
    id: '6',
    caption: 'Save Earth',
    fullImageAsset: {
      url: 'https://www.kamigroup.co/wp-content/uploads/2020/04/medioamb.jpg',
    },
  },
];

/**
 * Extra slider images for the carousel.
 */
export const ImageCarouselExtraImages = [
  {
    id: '7',
    caption: 'If We Have the Power to Damage, We Can Also Repair',
    fullImageAsset: {
      url: 'https://thetechpanda.com/wp-content/uploads/2019/02/environment.jpg',
    },
  },
  {
    id: '8',
    caption: 'NATURE BASED LEARNING: THE MICRO-HIKE',
    fullImageAsset: {
      url: 'https://voyagersoutdoor.weebly.com/uploads/2/3/5/8/23584336/9577164_orig.jpg',
    },
  },
  {
    id: '9',
    caption: 'NATURE',
    fullImageAsset: {
      url: 'https://www.wildlandspa.org/wp-content/uploads/2013/05/stream_restoration.jpg',
    },
  },
  {
    id: '10',
    caption: 'NATURE',
    fullImageAsset: {
      url: 'https://images-eu.ssl-images-amazon.com/images/I/910hhe6SqYL.jpg',
    },
  },
];

/**
 * Configuration for the swiper image carousel.
 */

export const SwiperImageCarouselConfiguration: SwiperOptions = {
  keyboard: {
    enabled: true,
  },
  effect: 'slide',
  flipEffect: {
    slideShadows: false,
  },
  cubeEffect: {
    shadow: true,
    slideShadows: false,
    shadowOffset: 20,
    shadowScale: 0.94,
  },
  loop: false,
  slidesPerView: 1,
  fadeEffect: {
    crossFade: true,
  },
  spaceBetween: 30,
  centeredSlides: true,
  simulateTouch: false,
  a11y: {
    prevSlideMessage: 'Previous slide',
    nextSlideMessage: 'Next slide',
  },
  mousewheel: true,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  scrollbar: {
    el: '.swiper-scrollbar',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  modules: [Navigation, Pagination, Scrollbar, A11y, EffectCube, EffectFade, EffectFlip, Autoplay, Manipulation],
  observer: true,
};
